module.exports = __webpack_public_path__ + "img/arrow_up.6b541ef1.svg";